import {
  CustomButton,
  CustomCollapseCard,
  CustomImage,
  CustomTable,
  errorDialog,
  Text,
} from '@src/components';
import React, { useCallback, useEffect } from 'react';
import '@src/styles/myInvoices/balanceReportList.scss';
import { useDispatch, useSelector } from 'react-redux';
import download from 'js-file-download';
import dayjs from '@src/utils/day';
import { getFileNameByLanguage } from '@src/utils/utils';
import excelIcon from '@src/assets/icons/icon-excel.svg';
import downloadIcon from '@src/assets/icons/icon-download-white.svg';
import cardBalancesServices from '@src/services/cardBalances.services';
import { useHistory } from 'react-router-dom';
import { resetCardBalancesList } from '@src/store/slice/cardBalancesSlice';
import { VouIdCode } from '@src/store/enums';
import PropTypes from 'prop-types';

const BalanceReportList = ({ form, segId, vouId }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { cardBalancesList } = useSelector((state) => state.cardBalances);
  const { selectedCustomer } = useSelector((state) => state.customer);

  useEffect(() => {
    dispatch(resetCardBalancesList());
  }, [history]);

  const excelDownload = useCallback(async () => {
    const values = await form.validateFields();

    let data = {
      customerId: selectedCustomer?.customerId,
      downloadType: 2,
      segId: segId,
      vouId: vouId,
      ...clearObject(values),
    };

    try {
      const blob = await cardBalancesServices.cardBalancesDownloadFile(data);
      // js-file-download's download() is synchronous (not Promise-returning) - no await needed.
      download(
        blob,
        `${getFileNameByLanguage('BakiyeRaporu', 'BalanceReport')}_${dayjs().format(
          'DD-MM-YYYY',
        )}.xlsx`,
      );
    } catch (error) {
      errorDialog({
        title: <Text t="error" />,
        message: error?.statusText,
      });
    }
  }, []);

  const clearObject = (values) => {
    let newObject = {};
    for (const key in values) {
      if (values[key] !== undefined && values[key] !== null && values[key] !== '') {
        newObject[key] = values[key];
      }
    }
    return newObject;
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: 30,
    },
    {
      title: <Text t="cardNumber4" />,
      dataIndex: 'cardNumber',
      key: 'cardNumber',
      align: 'left',
      width: 155,
    },
    {
      title: <Text t="referenceCode3" />,
      dataIndex: 'refId',
      key: 'refId',
      width: 110,
      align: 'left',
    },
    {
      title: <Text t="cardUserNameSurname" />,
      dataIndex: 'name',
      key: 'name',
      width: 100,
      align: 'center',
      render: (text, record) => {
        return (
          <div>
            <span>
              {text} {record?.surName}
            </span>
          </div>
        );
      },
    },
    {
      title: <Text t="cardStatus" />,
      dataIndex: 'cardState',
      key: 'cardState',
      width: 98,
      align: 'center',
    },
    {
      title: <Text t="balance" />,
      dataIndex: 'balance',
      key: 'balance',
      width: 110,
      align: 'left',
    },
  ];

  return (
    <>
      {cardBalancesList && (
        <CustomCollapseCard className="balance-report-list-card" cardTitle={<Text t="reports" />}>
          <div className="balance-report-header-tools">
            <CustomButton
              id="ticketRestaurant-myInvoices-balanceReport-balanceReportList-upload-btn"
              className="upload-btn"
              onClick={() => excelDownload()}
            >
              <CustomImage src={downloadIcon} />
              <Text t="downloadExcel" />
              <CustomImage src={excelIcon} />
            </CustomButton>
          </div>
          <CustomTable
            pagination={true}
            pageSize={10}
            dataSource={cardBalancesList}
            columns={columns}
            className="balance-report-list-table"
            rowKey={(record) => `balance-report-list-${record?.id}`}
          />
        </CustomCollapseCard>
      )}
    </>
  );
};

BalanceReportList.propTypes = {
  form: PropTypes.object.isRequired,
  segId: PropTypes.number.isRequired,
  vouId: PropTypes.string.isRequired,
};

export default BalanceReportList;
